<!--监控面版-->
<template>
    <Panel :title="'系统监控'">
        <template slot="buttons">
            <el-button type="primary" @click="mode = mode === 'system'? 'transform' : 'system'">切换</el-button>
        </template>
        <el-collapse-transition>
            <div v-if="mode === 'transform'">
                <Environment></Environment>
            </div>
        </el-collapse-transition>
        <el-collapse-transition>
            <div v-if="mode === 'system'">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <Panel title="数据监控">
                            <ve-line :data="DataMgr.chartData"></ve-line>
                        </Panel>
                    </el-col>
                    <el-col :span="12">
                        <Panel title="流量监控">
                            <ve-line :data="flowMgr.chartData"></ve-line>
                        </Panel>
                    </el-col>
                </el-row>
                <Panel title="资源监控">
                    <el-row>
                        <el-col :span="6">
                            <h1 style="text-align: center;">磁盘总量：{{ diskSpace.sum }}GB</h1>
                            <ve-ring :data="diskSpace.chartData" :settings="chartSettings"></ve-ring>
                        </el-col>
                        <el-col :span="6">
                            <h1 style="text-align: center;">内存总量：{{ sysMemory.sum }}GB</h1>
                            <ve-ring :data="sysMemory.chartData" :settings="chartSettings"></ve-ring>
                        </el-col>
                        <el-col :span="6">
                            <h1 style="text-align: center;">系统\应用占用率</h1>
                            <ve-ring :data="appMemory.chartData" :settings="chartSettings"></ve-ring>
                        </el-col>
                        <el-col :span="6">
                            <h1 style="text-align: center;">系统\应用CPU占用率</h1>
                            <ve-ring :data="cpuMemory.chartData" :settings="chartSettings"></ve-ring>
                        </el-col>
                    </el-row>
                </Panel>
            </div>
        </el-collapse-transition>

    </Panel>
</template>

<script>
import config from "cnetong-core-frontend/base/config";
import Environment from "./Environment.vue";
import HeaderApi from "@/module/layout/header/Header";

export default {
    components: {Environment},
    data() {
        return {
          auth: {
            authCode: '',
            authorized: false,
            staTime: 0,
            endTime: 0,
            serverTime: 0,
            status: '',
            //bizChainSynchronized: true,
            // 更新信息
            updateMark: false,
            versionName: '',
            versionNo: '',
            updateDate: '',
            versionSize: '',
            md5: '',
            // 以下为本页计算得到的
            title: '',
            suffix: '',
            level: 'none',
          },
            mode: 'system', // system系统监控/transform传输监控
            dateTime: '',
            DataMgr: {
                chartData: {
                    columns: ["时间", "接收(票)", "发送(票)"],
                    rows: []
                },
            },
            flowMgr: {
                chartData: {
                    columns: ["时间", "接收(兆)", "发送(兆)"],
                    rows: []
                },
            },
            chartSettings: {
                label: {show: false, position: 'center'}
            },
            diskSpace: {
                sum: "",
                chartData: {
                    columns: ["lable", "value"],
                    rows: [{lable: "未使用", value: 50}, {lable: "使用", value: 50}]
                },
            },
            sysMemory: {
                sum: "100",
                chartData: {
                    columns: ["lable", "value"],
                    rows: [{lable: "未使用", value: 50}, {lable: "使用", value: 50}]
                },
            },
            appMemory: {
                chartData: {
                    columns: ["lable", "value"],
                    rows: [{lable: "系统", value: 50}, {lable: "应用", value: 50}]
                },
            },
            cpuMemory: {
                chartData: {
                    columns: ["lable", "value"],
                    rows: [{lable: "系统", value: 50}, {lable: "应用", value: 50}]
                },
            },
            webSocket: null
        };
    },
    watch: {},
    async mounted() {
        await this.handleQuery();
        this.initWebSocket();
    },
    methods: {
        initWebSocket() {
            let sock;
            if (process.env.NODE_ENV === 'production') {
                sock = `ws://${config.context.domain}:${config.context.port}/asestatus`;
            } else {
                sock = `ws://localhost:9099/asestatus`;
            }

            this.webSocket = new WebSocket(sock);
            this.webSocket.onmessage = this.onMessage;
            this.webSocket.onclose = this.onClose;

            this.$once('hook:beforeDestroy', () => this.webSocket.close())
        },
        async handleQuery() {
          try {
            let resp = await HeaderApi.getInfo();
            Object.assign(this.auth, resp.data);
            this.computedAuthData();
          } finally {
          }
        },
      computedAuthData() {
        if (this.auth.authorized && this.auth.status === '1') {
          this.auth.title = '授权成功';
          this.auth.suffix = null;
          //this.auth.title = '授权不存在';
          //this.auth.suffix = '申请授权';
        } else if (this.auth.status === '6') {
          this.auth.title = '授权不存在';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '7') {
          this.auth.title = '授权申请未审批';
          this.auth.suffix = '查看审批进度';
        } else if (this.auth.status === '8') {
          this.auth.title = '授权申请未通过';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '9') {
          this.auth.title = '授权变更申请未审批';
          this.auth.suffix = '查看审批进度';
        } else if (this.auth.status === '10') {
          this.auth.title = '授权变更申请未通过';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '11') {
          this.auth.title = '授权已超期';
          this.auth.suffix = '申请授权';

        } else if (this.auth.status === '12') {
          this.auth.title = '授权延期申请未审批';
          this.auth.suffix = '查看审批进度';
        } else if (this.auth.status === '13') {
          this.auth.title = '授权延期申请未通过';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '14') {
          this.auth.title = '授权已禁用';
          this.auth.suffix = '反馈问题';
        } else {
          this.auth.title = '授权状态异常 - ' + this.auth.status;
          this.auth.suffix = '反馈问题';
        }
        if( this.auth.status !== '1'){
          this.$router.push("/login");
        }
        if (!this.auth.authorized || this.auth.serverTime > this.auth.endTime) {
          this.auth.level = "failure";
        } else if (this.auth.endTime - this.auth.serverTime < 24 * 60 * 60 * 1000 * 15) {
          this.auth.level = "warning";
        } else {
          this.auth.level = "success";
        }
      },
        onMessage(e) {
            // 数据接收
            const redata = JSON.parse(e.data);
            if (redata.wstype === "ws06") {
            } else if (redata.wstype === "ws01") {
                if (this.DataMgr.chartData.rows.length > 9) {
                    // 10次以上执行清除
                    this.DataMgr.chartData.rows.splice(0, 1);
                }
                this.DataMgr.chartData.rows.push({
                    '时间': new Date().toLocaleTimeString().replace(/^\D*/, ""),
                    '接收(票)': redata.sqps,
                    '发送(票)': redata.pqps
                });
                if (this.flowMgr.chartData.rows.length > 9) {
                    // 10次以上执行清除
                    this.flowMgr.chartData.rows.splice(0, 1);
                }
                this.flowMgr.chartData.rows.push({
                    '时间': new Date().toLocaleTimeString().replace(/^\D*/, ""),
                    '接收(兆)': (redata.scps / 1024 / 1024).toFixed(2),
                    '发送(兆)': (redata.pcps / 1024 / 1024).toFixed(2)
                });
            } else if (redata.wstype === "02") {
                this.diskSpace.sum = (redata.total / 1024 / 1024 / 1024).toFixed(2);
                this.diskSpace.chartData.rows = [
                    {
                        lable: "使用",
                        value: ((redata.total - redata.free) / 1024 / 1024 / 1024).toFixed(
                            2
                        )
                    },
                    {
                        lable: "未使用",
                        value: (redata.free / 1024 / 1024 / 1024).toFixed(2)
                    }
                ];
            } else if (redata.wstype === "03") {
                this.sysMemory.sum = (redata.total / 1024 / 1024 / 1024).toFixed(2);
                this.sysMemory.chartData.rows = [
                    {
                        lable: "使用",
                        value: ((redata.total - redata.free) / 1024 / 1024 / 1024).toFixed(
                            2
                        )
                    },
                    {
                        lable: "未使用",
                        value: (redata.free / 1024 / 1024 / 1024).toFixed(2)
                    }
                ];
            } else if (redata.wstype === "04") {
                this.appMemory.chartData.rows = [
                    {
                        lable: "应用",
                        value: ((redata.mem - redata.use) / 1024 / 1024).toFixed(2)
                    },
                    {lable: "系统", value: (redata.use / 1024 / 1024).toFixed(2)}
                ];
            } else if (redata.wstype === "05") {
                this.cpuMemory.chartData.rows = [
                    {lable: "应用", value: Math.ceil(redata.jvmuse)},
                    {lable: "系统", value: Math.ceil(redata.sysuse)}
                ];
            } else if (redata.wstype === "ws07") {
                console.log(redata);
            }
        },
        onClose(e) {
            console.log("connection closed (" + e.code + ")");
            setTimeout(this.initWebSocket, 5000);
        }
    }
};
</script>

<style lang="scss">
</style>
